module.exports = __webpack_public_path__ + "62469eeea0df22ed5ff39a85689003da.png";